import React, { useState } from "react";
import { replace, useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { Star, eye_view } from "../../assets/img";
import { post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";

const ReviewView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  const [previewPopup, setPreviewPopup] = useState({ type: null, url: null });
  const [reasonPopup, setReasonPopup] = useState({ isOpen: false, complaintId: null, text: "" });
  console.log("data review", data);

  const handleStatus = async (status) => {
    if (!checkPermission("CAN-EDIT-REVIEW")) return;
    const payload = {
      review_id: data?.id,
      status: status,
    };

    const res = await post(URLS.REVIEW_STATUS, payload);
    console.log("review status", res);
    if (res?.status === "success") {
      toast.success(
        data?.status === 1
          ? res?.message
          : `Review ${status === 2 ? "Activated" : "Deactivated"} Successfully`,
      );

      navigate("/review", {
        state: { tab: status === 3 ? "Deactivate" : "Active", replace: true },
      });
    }
  };

  const handleRespondNow = (complaintId) => {
    setReasonPopup({ isOpen: true, complaintId, text: "" });
  };

  const handleConfirmRespond = async () => {
    const { complaintId, text } = reasonPopup;
    if (!text) {
      toast.error("Please enter a reason");
      return;
    }
    
    const payload = {
      complaint_id: complaintId,
      description: text,
    };

    const res = await put("master/complaint-admin-status-update/", payload);
    if (res?.status === "success" || res?.success) {
      toast.success(res?.message || "Response submitted successfully");
      setReasonPopup({ isOpen: false, complaintId: null, text: "" });
      navigate("/review", {
        state: { tab: "Complaints", complaintTab: "Responded", replace: true },
      });
    } else {
      toast.error(res?.message || "Failed to submit response");
    }
  };

  return (
    <>
      <Topbar header={"Review"} back={true} />

      <div className="row mt-5">
        <form className="d-flex flex-wrap gap-5">
          <div className="col-md-5"></div>
          <div className="col-md-5 d-flex ae-js gap-4">
            <div className="px-4 py-2 shadow-sm radius-10">
              <p className=" fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Date
              </p>
              <h6 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                {moment(data?.created_at).format("DD-MM-YYYY")}
              </h6>
            </div>
            <div className="shadow-sm px-4 py-2 radius-10">
              <p className=" fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Time
              </p>
              <h6 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                {moment(data?.created_at).format("hh:mm:ss")}
              </h6>
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Property
              </label>
              <input
                value={data?.property_name}
                className="input-box"
                placeholder="property"
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                User
              </label>
              <input
                className="input-box"
                placeholder="User"
                value={data?.user_name}
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Booking ID
              </label>
              <input
                value={data?.booking_code}
                className="input-box"
                placeholder="Booking Id"
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Owner
              </label>
              <input
                value={data?.owner_name}
                className="input-box"
                placeholder="Owner"
                disabled
              />
            </div>
          </div>
          <div className="col-md-5">
            <div style={{ width: "95%" }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Review
              </label>
              <div className="d-flex gap-3 mt-2">
                {Array(Math.floor(data?.rating))
                  .fill(0)
                  .map(() => (
                    <img
                      className="Star_icon"
                      src={Star}
                      style={{ height: "30px", width: "30px" }}
                    />
                  ))}
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Location
              </label>
              <input
                value={`${data?.city},${data?.state}`}
                className="input-box"
                placeholder="Owner"
                disabled
              />
            </div>
          </div>

          <div className="col-md-11">
            <div style={{ width: "95%" }}>
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Description
              </label>
              <textarea
                className="input-box"
                value={data?.description}
                placeholder="Text..."
                style={{ minHeight: "131px" }}
                disabled
              />
            </div>
          </div>

        

          <>
            <div className="col-lg-11 justify-content-start ">
              <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Status
              </label>
              <div className="d-flex as-js gap-5">
                {(data?.status === 1 || data?.status === 3) && (
                  <button
                    type="button"
                    style={{ width: "200px" }}
                    className="approve-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={() => {
                      handleStatus(2);
                    }}
                  >
                    Active
                  </button>
                )}
                {(data?.status === 1 || data?.status === 2) && (
                  <button
                    type="button"
                    style={{ width: "200px" }}
                    className="reject1-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={() => {
                      handleStatus(3);
                    }}
                  >
                    Deactivate
                  </button>
                )}
              </div>
            </div>
          </>


            {data?.has_complaint === "yes" &&
            data?.complaint_reviews?.map((complaint) => (
              <div className="col-md-11  " key={complaint.id}>
                <div
                  className=" py-4 "
                  style={{ borderTop: "2px dashed #D1D5DB" }}
                >
                  <h4
                    className="f2 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-3"
                    style={{ color: "#a55eea" }}
                  >
                    Help to product VOW
                  </h4>
                  <div className="row gap-y-3">
                    <div className="col-md-6 mt-3">
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Person Name
                      </label>
                      <input
                        className="input-box"
                        value={complaint.name}
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Mobile number
                      </label>
                      <input
                        className="input-box"
                        value={complaint.mobile_number}
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mt-3">
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Photo
                      </label>
                      <div className="position-relative">
                        <input
                          className="input-box pe-5"
                          value={complaint.images?.length ? "User-image.jpg" : "No image"}
                          disabled
                        />
                        {complaint.images?.length > 0 && (
                          <div 
                            className="position-absolute d-flex align-items-center justify-content-center cursor-pointer"
                            style={{ right: "15px", top: "50%", transform: "translateY(-50%)", borderLeft: "2px solid #ccc", paddingLeft: "10px", height: "50%" }}
                          >
                            <img
                              src={eye_view}
                              alt="View"
                              style={{ width: "20px", cursor: "pointer" }}
                              onClick={() => setPreviewPopup({ type: 'image', url: complaint.images[0].image })}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 mt-3">
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Voice
                      </label>
                      <div className="position-relative">
                        <input
                          className="input-box pe-5"
                          value={complaint.user_voice ? "User-Voice.MP3" : "No voice"}
                          disabled
                        />
                        {complaint.user_voice && (
                          <div 
                            className="position-absolute d-flex align-items-center justify-content-center cursor-pointer"
                            style={{ right: "15px", top: "50%", transform: "translateY(-50%)", borderLeft: "2px solid #ccc", paddingLeft: "10px", height: "50%" }}
                          >
                            <svg 
                              width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                              style={{ cursor: "pointer" }}
                              onClick={() => setPreviewPopup({ type: 'audio', url: complaint.user_voice })}
                            >
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 mt-3">
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Description
                      </label>
                      <textarea
                        className="input-box"
                        value={complaint.description}
                        disabled
                        style={{ minHeight: "100px" }}
                      />
                    </div>
                    {complaint.status !== "Pending" && (
                      <>
                        <div className="col-md-12 mt-3">
                          <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                            Admin Response
                          </label>
                          <textarea
                            className="input-box"
                            value={complaint.admin_description || ""}
                            disabled
                            style={{ minHeight: "100px" }}
                          />
                        </div>
                        <div className="col-md-12 mt-3">
                          <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                            Admin with date and time
                          </label>
                          <input
                            className="input-box"
                            value={`${complaint.admin || "-"} - ${
                              complaint.updated_at
                                ? moment(complaint.updated_at).format("DD-MM-YYYY hh:mm A")
                                : "-"
                            }`}
                            disabled
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {complaint.status === "Pending" && (
                    <button
                      type="button"
                      className="approve-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-4"
                      style={{
                        width: "150px",
                        backgroundColor: "#a55eea",
                        border: "none",
                        color: "white"
                      }}
                      onClick={() => handleRespondNow(complaint.id)}
                    >
                      Respond Now
                    </button>
                  )}
                </div>
              </div>
            ))}
        </form>
      </div>

      {previewPopup.type && (
        <div className="img-popup-design" style={{ zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="img-popup d-flex flex-column" style={{ padding: "20px", borderRadius: "15px", backgroundColor: "#fff", width: previewPopup.type === 'image' ? "600px" : "400px", maxWidth: "90%" }}>
            <h4 className="mb-3 f2 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">{previewPopup.type === 'image' ? 'User Image' : 'User voice'}</h4>
            {previewPopup.type === 'image' && (
              <img src={previewPopup.url} alt="Preview" style={{ width: "100%", borderRadius: "15px", marginBottom: "20px", maxHeight: "350px", objectFit: "cover" }} />
            )}
            {previewPopup.type === 'audio' && (
              <div style={{ padding: "10px", border: "1px solid #e0e0e0", borderRadius: "10px", marginBottom: "20px" }}>
                 <audio controls src={previewPopup.url} style={{ width: "100%" }} />
              </div>
            )}
            <button
              className="approve-btn w-100 f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 py-2"
              style={{ backgroundColor: "#a55eea", border: "none", color: "white", borderRadius: "10px" }}
              onClick={() => setPreviewPopup({ type: null, url: null })}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {reasonPopup.isOpen && (
        <div className="img-popup-design" style={{ zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="img-popup d-flex flex-column" style={{ padding: "30px", borderRadius: "30px", backgroundColor: "#f6f6f6", width: "400px", maxWidth: "90%" }}>
            <h4 className="mb-4 text-center f2 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22" style={{ fontWeight: "600", color: "#000" }}>Reason</h4>
            
            <input
              type="text"
              value={reasonPopup.text}
              onChange={(e) => setReasonPopup({ ...reasonPopup, text: e.target.value })}
              placeholder="I will Take the action for this..."
              style={{
                width: "100%",
                border: "none",
                borderBottom: "1px solid #999",
                outline: "none",
                padding: "10px 0",
                marginBottom: "40px",
                fontSize: "16px",
                color: "#555",
                backgroundColor: "transparent"
              }}
            />

            <div className="d-flex justify-content-between align-items-center">
              <button
                className="f2 fs-sm-14 fs-md-16 fs-lg-18"
                style={{ backgroundColor: "transparent", border: "none", color: "#000", padding: "10px" }}
                onClick={() => setReasonPopup({ isOpen: false, complaintId: null, text: "" })}
              >
                Go Back
              </button>
              <button
                className="f2 fs-sm-14 fs-md-16 fs-lg-18"
                style={{
                  backgroundColor: "#FCE7E7",
                  border: "none",
                  color: "#FF4D4F",
                  padding: "10px 20px",
                  borderRadius: "10px"
                }}
                onClick={handleConfirmRespond}
              >
                Confirm Responded
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewView;
